/* Whisply new-site slide cart.
   Server-rendered section `wn-cart` (Section Rendering API). Every mutation goes through one
   serial queue, re-renders the drawer from the response, then reconciles the managed lines
   (care kit, tier gifts, protection, warranty, gift box, Rx lens fees) exactly like the live
   whisply-cart.js. Public API: window.WNCart = { open, close, refresh, add, toast }.
   Event in:  document 'wn:cart:refresh' {detail:{open:true}}  (anything that added to the cart)
   Event out: document 'wn:cart:updated' {detail: state}       (after every re-render) */
(function () {
  'use strict';
  if (window.WNCart && window.WNCart.__wc) return;

  var SECTION = 'wn-cart';
  var ROOT = (window.WN && window.WN.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var OPTOUT = 'whisply_protection_optout'; /* same keys as live so a shopper's choice carries over */
  var WOFF = 'whisply_warranty_off';
  var TIMER = 'wn_cart_timer_end';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var drawer = $('#CartDrawer');
  var scrim = $('[data-cart-scrim]');
  var lastFocus = null;
  var failed = {};      /* variant ids whose auto-add failed this page view: never retried (loop guard) */
  var reconciling = false;

  /* ---------- serial queue: one cart request at a time, in order ---------- */
  var chain = Promise.resolve();
  var pending = 0;
  function enqueue(fn) {
    pending++; setBusy(true);
    var run = chain.then(fn);
    chain = run.catch(function () {}).then(function () { pending--; if (!pending) setBusy(false); });
    return run;
  }
  function setBusy(on) { var r = cartRoot(); if (r) r.classList.toggle('is-busy', on); }

  function cartRoot() { return drawer && $('[data-cart-root]', drawer); }
  function state() {
    var el = drawer && $('[data-wc-state]', drawer);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- network ---------- */
  function post(path, body) {
    body = body || {};
    body.sections = SECTION;
    body.sections_url = location.pathname;
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong. Try again.');
        if (j.sections && j.sections[SECTION]) render(j.sections[SECTION]);
        return j;
      });
    });
  }
  function fetchSection() {
    return fetch(ROOT + '?sections=' + SECTION + '&_wc=' + Date.now(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j[SECTION]) render(j[SECTION]); });
  }

  /* ---------- render ---------- */
  function render(html) {
    var root = cartRoot();
    if (!root || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-root]');
    if (!next) return;
    var sc = $('[data-wc-scroll]', root), top = sc ? sc.scrollTop : 0;
    var code = $('.wc-code', root), codeOpen = code && code.open;
    var inp = $('[data-wc-code-input]', root), codeVal = inp ? inp.value : '';
    var focusSel = document.activeElement && root.contains(document.activeElement) ? focusKey(document.activeElement) : null;
    if (pending) next.classList.add('is-busy');
    var wasOn = $$('.wc-mark.is-on', root).map(function (m) { return m.dataset.tier; });
    var wasGift = $$('.wc-line.is-gift', root).map(function (m) { return m.dataset.key; });
    var hadCart = !!$('.wc-lines', root);
    var oldFill = $('.wc-fill', root), oldW = oldFill ? oldFill.style.getPropertyValue('--p') : null;
    root.replaceWith(next);
    /* progress fills grow from their previous value instead of jumping */
    var nf = $('.wc-fill', next);
    var from = oldW === null ? '0%' : oldW;
    var to = nf ? nf.style.getPropertyValue('--p') : null;
    if (nf && from !== to) { nf.style.setProperty('--p', from); void nf.offsetWidth; requestAnimationFrame(function () { nf.style.setProperty('--p', to); }); }
    /* celebrate only what was just unlocked */
    if (hadCart) {
      $$('.wc-mark.is-on', next).forEach(function (m) { if (wasOn.indexOf(m.dataset.tier) < 0) m.classList.add('is-new'); });
      $$('.wc-line.is-gift', next).forEach(function (m) { if (wasGift.indexOf(m.dataset.key) < 0) m.classList.add('is-new'); });
    }
    var sc2 = $('[data-wc-scroll]', next); if (sc2) sc2.scrollTop = top;
    var code2 = $('.wc-code', next); if (code2 && codeOpen) code2.open = true;
    var inp2 = $('[data-wc-code-input]', next); if (inp2 && codeVal) inp2.value = codeVal;
    if (focusSel) { var f = next.querySelector(focusSel); (f || $('[data-close-cart]', next)).focus({ preventScroll: true }); }
    var n = next.getAttribute('data-count');
    $$('[data-cart-count],[data-w-cart-count]').forEach(function (b) {
      if (b.textContent === n) return;
      b.textContent = n; b.dataset.n = n;
      b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
    });
    tick();
    try { if (window.Shopify && Shopify.StorefrontExpressButtons) Shopify.StorefrontExpressButtons.initialize(); } catch (e) {}
    var st = state();
    document.dispatchEvent(new CustomEvent('wn:cart:updated', { detail: st }));
    document.dispatchEvent(new CustomEvent('whisply:cart', { detail: st })); /* same event the live cart fires for apps/analytics */
  }
  /* keep keyboard focus on the same control across a re-render */
  function focusKey(el) {
    var li = el.closest('[data-key]');
    var base = li ? '[data-key="' + li.dataset.key + '"] ' : '';
    var attrs = ['data-wc-f', 'data-wc-warr', 'data-wc-toggle', 'data-wc-wrap', 'data-add', 'data-wc-code'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) {
        var v = el.getAttribute(attrs[i]);
        return base + '[' + attrs[i] + (v ? '="' + v + '"' : '') + ']';
      }
    }
    return null;
  }

  /* ---------- managed-line rules (ported from live whisply-cart.js reconcile) ---------- */
  function sum(arr) { return arr.reduce(function (a, l) { return a + l.q; }, 0); }
  function isManaged(st, id) { return (st.managed || '').indexOf(',' + id + ',') > -1; }
  function mainLines(st, lines) {
    return lines.filter(function (l) { return !l.fee && !l.wFor && !l.wrapFor && l.price > 0 && !isManaged(st, l.id); });
  }
  function covers(lines, key) {
    return lines.filter(function (l) {
      return !l.fee && !l.wFor && !l.wrapFor && (key.indexOf('rx:') === 0 ? l.rx && 'rx:' + l.pair === key : !l.rx && 'v:' + l.id === key);
    });
  }
  function wrapped(lines, vid) {
    return lines.filter(function (l) { return String(l.id) === String(vid) && !l.fee && !l.wFor && !l.wrapFor; });
  }
  /* dependants follow their pair: Rx fee, warranty and gift box quantities */
  function syncUpdates(lines, base) {
    var u = {};
    lines.forEach(function (f) {
      var orig = base ? (base.filter(function (b) { return b.key === f.key; })[0] || f) : f, q;
      if (f.fee) q = sum(lines.filter(function (l) { return l.pair && l.pair === f.pair && !l.fee; }));
      else if (f.wFor) q = sum(covers(lines, f.wFor));
      else if (f.wrapFor) q = sum(wrapped(lines, f.wrapFor));
      else if (f.aFor) q = covers(lines, f.aFor).length ? orig.q : 0;
      else return;
      if (orig.q !== q) u[f.key] = q;
    });
    return u;
  }
  function plan(st) {
    var lines = st.lines, updates = {}, add = [];
    var byId = function (id) { return lines.filter(function (l) { return l.id === id; }); };
    var main = mainLines(st, lines);
    var one = function (id, want) {
      byId(id).forEach(function (l, i) { if (!want || i > 0) updates[l.key] = 0; else if (l.q !== 1) updates[l.key] = 1; });
      if (want && !byId(id).length && !failed[id]) add.push({ id: id, quantity: 1 });
    };
    if (st.kit) one(st.kit, st.kitWhen === 'eyewear' ? st.eyewear > 0 : main.length > 0);
    (st.tiers || []).filter(Boolean).forEach(function (t) { one(t.id, st.qualified >= t.at && main.length > 0); });
    if (st.prot) {
      var prot = byId(st.prot);
      if (!main.length) prot.forEach(function (l) { updates[l.key] = 0; });
      else {
        prot.forEach(function (l, i) { if (i > 0) updates[l.key] = 0; else if (l.q !== 1) updates[l.key] = 1; });
        if (st.protAuto && !store.get(OPTOUT) && !prot.length && !failed[st.prot]) add.push({ id: st.prot, quantity: 1 });
      }
    }
    if (st.prio && !main.length) byId(st.prio).forEach(function (l) { updates[l.key] = 0; });
    var s = syncUpdates(lines);
    Object.keys(s).forEach(function (k) { updates[k] = s[k]; });
    if (st.wOn && st.wAuto) {
      var off = []; try { off = JSON.parse(store.get(WOFF) || '[]'); } catch (e) {}
      var keys = [];
      lines.filter(function (l) { return !l.fee && !l.wFor && !l.wrapFor && l.price > 0 && (l.eye || l.rx); })
        .forEach(function (l) { var k = l.rx ? 'rx:' + l.pair : 'v:' + l.id; if (keys.indexOf(k) < 0) keys.push(k); });
      keys.forEach(function (k) {
        if (off.indexOf(k) > -1 || lines.some(function (l) { return l.wFor === k; })) return;
        var id = k.indexOf('rx:') === 0 ? st.wr : st.wb; if (!id || failed[id + k]) return;
        var g = covers(lines, k);
        add.push({ id: id, quantity: sum(g), properties: { For: g[0] ? g[0].title || '' : '', '_Warranty for': k }, _fk: id + k });
      });
    }
    return { updates: updates, add: add };
  }
  /* runs inside the queue; at most 3 passes so a stubborn line can never loop */
  function reconcile() {
    if (reconciling) return Promise.resolve();
    reconciling = true;
    var pass = 0;
    function step() {
      var st = state();
      if (!st || pass++ >= 3) return Promise.resolve();
      var p = plan(st);
      var hasU = Object.keys(p.updates).length, hasA = p.add.length;
      if (!hasU && !hasA) return Promise.resolve();
      var go = Promise.resolve();
      if (hasU) go = go.then(function () { return post('cart/update.js', { updates: p.updates }); });
      if (hasA) {
        go = go.then(function () {
          var items = p.add.map(function (a) { var c = { id: a.id, quantity: a.quantity }; if (a.properties) c.properties = a.properties; return c; });
          return post('cart/add.js', { items: items }).catch(function () {
            /* one bad item fails the batch: retry one by one, remember the ones that fail */
            return p.add.reduce(function (pr, a) {
              return pr.then(function () {
                var c = { id: a.id, quantity: a.quantity }; if (a.properties) c.properties = a.properties;
                return post('cart/add.js', { items: [c] }).catch(function () { failed[a._fk || a.id] = 1; });
              });
            }, Promise.resolve());
          });
        });
      }
      return go.then(step);
    }
    return step().catch(function (e) { if (window.console) console.warn('[wn-cart]', e); }).then(function () { reconciling = false; });
  }

  /* ---------- open / close ---------- */
  var isPage = !!(drawer && drawer.classList.contains('is-page')); /* /cart renders the same cart inline */
  function open() {
    if (!drawer) return;
    if (isPage) { var r = drawer.getBoundingClientRect(); if (r.top > innerHeight * .6 || r.bottom < 80) drawer.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (!drawer.classList.contains('on')) lastFocus = document.activeElement;
    drawer.classList.add('on');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    document.documentElement.classList.add('wc-lock');
    $$('.rb i', drawer).forEach(function (i) { i.style.animation = 'none'; void i.offsetWidth; i.style.animation = ''; });
    setTimeout(function () { var x = $('[data-close-cart]', drawer); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!drawer || isPage || !drawer.classList.contains('on')) return;
    drawer.classList.remove('on');
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('on');
    document.documentElement.classList.remove('wc-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- public actions ---------- */
  function refresh(opts) {
    opts = opts || {};
    if (opts.added) store.set(OPTOUT, '');
    var p = enqueue(function () { return fetchSection().then(reconcile); });
    if (opts.open) p.then(open, open);
    return p;
  }
  function add(items, opts) {
    opts = opts || {};
    if (!Array.isArray(items)) items = [items];
    store.set(OPTOUT, ''); /* live: a new product re-offers protection */
    return enqueue(function () {
      return post('cart/add.js', { items: items }).then(function (res) { return reconcile().then(function () { return res; }); });
    }).then(function (res) { if (opts.open !== false) open(); return res; });
  }
  function change(key, qty) {
    return enqueue(function () {
      var st = state(); if (!st) return;
      var lines2 = st.lines.map(function (l) { return l.key === key ? Object.assign({}, l, { q: qty }) : l; });
      var updates = syncUpdates(lines2, st.lines);
      updates[key] = qty;
      return post('cart/update.js', { updates: updates }).then(reconcile);
    });
  }
  function toast(msg) {
    var t = $('[data-toast]'); if (!t || !msg) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  /* errors: inside the open bag they read as one quiet line above the totals; elsewhere the global toast */
  var FRIENDLY = [
    [/cannot find variant|variant.*not found|invalid.*variant/i, 'This piece is not available at the moment.'],
    [/sold out|out of stock/i, 'This piece has just sold out.'],
    [/failed to fetch|network/i, 'The connection was interrupted. Please try again.']
  ];
  function nice(m) {
    m = m || 'Something went wrong. Please try again.';
    for (var i = 0; i < FRIENDLY.length; i++) if (FRIENDLY[i][0].test(m)) return FRIENDLY[i][1];
    return m;
  }
  function alertLine(msg) {
    var a = drawer && $('[data-wc-alert]', drawer);
    var visible = drawer && (isPage || drawer.classList.contains('on'));
    if (!a || !visible) return false;
    a.textContent = msg; a.hidden = false;
    clearTimeout(alertLine._t); alertLine._t = setTimeout(function () { var b = drawer && $('[data-wc-alert]', drawer); if (b) b.hidden = true; }, 7000);
    return true;
  }
  function fail(e) { var m = nice(e && e.message); if (!alertLine(m)) toast(m); }
  function codeMsg(msg, kind) {
    var el = drawer && $('[data-wc-code-msg]', drawer);
    if (!el) return;
    el.textContent = msg; el.className = 'wc-code-msg' + (kind ? ' is-' + kind : '');
  }

  /* ---------- rolling 10-minute reservation timer ---------- */
  var timerId = null;
  function tick() {
    var els = $$('[data-wc-timer]');
    if (!els.length) { clearInterval(timerId); timerId = null; return; }
    var end = 0; try { end = +sessionStorage.getItem(TIMER) || 0; } catch (e) {}
    var now = Date.now();
    if (end <= now) { end = now + 600000; try { sessionStorage.setItem(TIMER, String(end)); } catch (e) {} }
    var s = Math.max(0, Math.round((end - now) / 1000));
    var txt = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
    els.forEach(function (el) { el.textContent = txt; });
    if (!timerId) timerId = setInterval(tick, 1000);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-open-cart]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-close-cart]') || t.closest('[data-cart-scrim]')) { close(); return; }

    var a = t.closest('[data-add]');
    if (a && a.dataset.add) {
      e.preventDefault();
      if (a.disabled) return;
      a.disabled = true; a.classList.add('is-busy');
      add([{ id: +a.dataset.add, quantity: 1 }]).catch(fail).then(function () { a.disabled = false; a.classList.remove('is-busy'); });
      return;
    }
    if (!drawer || !drawer.contains(t)) return;

    var go = t.closest('[data-wc-rail-go]');
    if (go) {
      var rl = go.closest('.wc-rail-ft'); rl = rl && rl.parentNode && $('[data-wc-rail]', rl.parentNode);
      if (rl) rl.scrollBy({ left: (+go.dataset.wcRailGo) * rl.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var pick = t.closest('[data-wc-pick]');
    if (pick) {
      /* fold the shelf so the new pair is in view when the bag comes back */
      var shelfEl = pick.closest('[data-wc-b2x]'); if (shelfEl) shelfEl.open = false;
      if (window.WNQuickBuy && typeof window.WNQuickBuy.open === 'function') { close(); window.WNQuickBuy.open(pick.dataset.handle, { mode: 'frame', variant: pick.dataset.variant, source: 'cart' }); return; }
      pick.disabled = true;
      add([{ id: +pick.dataset.variant, quantity: 1 }]).catch(fail).then(function () { pick.disabled = false; });
      return;
    }

    var q = t.closest('[data-wc-qty]');
    if (q) {
      var li = q.closest('[data-key]'); if (!li) return;
      li.classList.add('is-busy');
      change(li.dataset.key, Math.max(0, parseInt(q.dataset.wcQty, 10) || 0)).catch(function (er) { li.classList.remove('is-busy'); fail(er); });
      return;
    }

    var wr = t.closest('[data-wc-warr]');
    if (wr) {
      /* data-wc-warr="t": one checkbox that toggles; "on" / "off": the older two-button radio */
      var single = wr.dataset.wcWarr === 't';
      if (!single && wr.getAttribute('aria-checked') === 'true') return;
      var box = wr.closest('[data-wkey]'), key = box.dataset.wkey;
      var on = single ? wr.getAttribute('aria-checked') !== 'true' : wr.dataset.wcWarr === 'on';
      if (single) wr.setAttribute('aria-checked', String(on));
      else $$('[data-wc-warr]', box).forEach(function (b) { b.setAttribute('aria-checked', String(b === wr)); });
      var off = []; try { off = JSON.parse(store.get(WOFF) || '[]'); } catch (er) {}
      off = off.filter(function (x) { return x !== key; }); if (!on) off.push(key);
      store.set(WOFF, JSON.stringify(off.slice(-40)));
      enqueue(function () {
        var st = state(), existing = st.lines.filter(function (l) { return l.wFor === key; });
        if (on && !existing.length) {
          var qty = sum(covers(st.lines, key)) || 1, line = wr.closest('[data-key]');
          return post('cart/add.js', { items: [{ id: +box.dataset.wid, quantity: qty, properties: { For: label(line), '_Warranty for': key } }] });
        }
        if (!on && existing.length) {
          var u = {}; existing.forEach(function (x) { u[x.key] = 0; });
          return post('cart/update.js', { updates: u });
        }
      }).catch(fail);
      return;
    }

    if (t.closest('[data-wc-code]')) {
      var input = $('[data-wc-code-input]', drawer), code = input ? input.value.trim() : '';
      if (!code) { if (input) input.focus(); return; }
      codeMsg('', '');
      enqueue(function () {
        var codes = [];
        /* keep codes already applied, add the new one */
        $$('.wc-chip', drawer).forEach(function (c) { codes.push(c.dataset.code); });
        if (codes.indexOf(code) < 0) codes.push(code);
        return post('cart/update.js', { discount: codes.join(',') }).then(function (cart) {
          var ok = (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
          if (ok) { var i2 = $('[data-wc-code-input]', drawer); if (i2) i2.value = ''; }
          return reconcile().then(function () {
            /* inline, next to the field (no toast over the checkout buttons) */
            codeMsg(ok ? code.toUpperCase() + ' has been applied.' : 'The code ' + code.toUpperCase() + ' cannot be applied to this order.', ok ? 'ok' : 'err');
          });
        });
      }).catch(function (er) { codeMsg(er && er.message ? er.message : 'The code could not be checked. Please try again.', 'err'); });
      return;
    }
    var un = t.closest('[data-wc-uncode]');
    if (un) {
      var keep = [];
      $$('.wc-chip', drawer).forEach(function (c) { if (!c.contains(un)) keep.push(c.dataset.code); });
      enqueue(function () { return post('cart/update.js', { discount: keep.join(',') }).then(reconcile); }).catch(fail);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!drawer || !drawer.contains(t)) return;
    var tg = t.closest('[data-wc-toggle]');
    if (tg) {
      var id = parseInt(tg.dataset.wcToggle, 10), on = tg.checked;
      if (tg.dataset.kind === 'prot') store.set(OPTOUT, on ? '' : '1');
      enqueue(function () {
        var st = state();
        var has = st.lines.filter(function (l) { return l.id === id; });
        if (on && !has.length) return post('cart/add.js', { items: [{ id: id, quantity: 1 }] });
        if (!on && has.length) { var u = {}; has.forEach(function (l) { u[l.key] = 0; }); return post('cart/update.js', { updates: u }); }
      }).catch(fail);
      return;
    }
    var w = t.closest('[data-wc-wrap]');
    if (w) {
      var li = w.closest('[data-key]'), on2 = w.checked;
      enqueue(function () {
        var st = state(), line = st.lines.filter(function (l) { return l.key === li.dataset.key; })[0];
        if (!line || !st.wrapId) return;
        var vid = String(line.id), existing = st.lines.filter(function (l) { return String(l.wrapFor) === vid; });
        if (on2 && !existing.length) {
          return post('cart/add.js', { items: [{ id: st.wrapId, quantity: sum(wrapped(st.lines, vid)) || 1, properties: { For: label(li), '_Wrap for': vid } }] });
        }
        if (!on2 && existing.length) { var u = {}; existing.forEach(function (x) { u[x.key] = 0; }); return post('cart/update.js', { updates: u }); }
      }).catch(fail);
    }
  });
  function label(li) {
    if (!li) return '';
    var n = $('[data-wc-name]', li), v = $('[data-wc-var]', li);
    return (n ? n.textContent.trim() : '') + (v ? ' – ' + v.textContent.trim() : '');
  }

  /* checkout waits for any in-flight cart change so the order matches the drawer */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!drawer || !drawer.contains(f) || !$('[data-wc-checkout]', f) || !pending) return;
    e.preventDefault();
    var b = $('[data-wc-checkout]', f); if (b) b.classList.add('is-busy');
    chain.then(function () {
      var form = $('.wc-co-f', drawer);
      if (form) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; form.appendChild(i); form.submit(); }
      else location.href = ROOT + 'checkout';
    });
  });

  /* Enter in the code field applies it */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-wc-code-input]')) return;
    e.preventDefault();
    var btn = $('[data-wc-code]', drawer); if (btn) btn.click();
  });
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('on')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),summary,[tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('wn:cart:refresh', function (e) {
    var d = (e && e.detail) || {};
    refresh({ open: !!d.open, added: d.open || d.action === 'add' });
  });
  /* Shopify / app integrations that announce cart changes */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.detail && e.detail.source === 'wn-cart') return;
    (e.promise || Promise.resolve()).then(function () { refresh({ added: e.action === 'add' }); }, function () { refresh(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* shelves: a 1px hairline under each rail with a short blue segment that tracks horizontal scroll */
  function railSync(rail) {
    var bar = rail && rail.parentNode && $('[data-wc-rail-bar]', rail.parentNode);
    if (!bar) return;
    var sw = rail.scrollWidth, cw = rail.clientWidth;
    var prog = bar.parentNode;
    if (!cw || sw <= cw + 2) { prog.classList.add('is-none'); return; }
    prog.classList.remove('is-none');
    var w = cw / sw, x = rail.scrollLeft / (sw - cw) * (1 - w);
    bar.style.width = (w * 100).toFixed(2) + '%';
    bar.style.transform = 'translateX(' + (x / w * 100).toFixed(2) + '%)';
  }
  function railsAll() { $$('[data-wc-rail]').forEach(railSync); }

  /* /cart on phones: show the slim checkout bar only while the real summary is off screen */
  var footIO = null;
  function watchFoot() {
    if (!isPage || !('IntersectionObserver' in window) || !drawer) return;
    if (footIO) footIO.disconnect();
    var foot = $('.wc-foot', drawer), bar = $('[data-wc-sticky]', drawer);
    if (!foot || !bar) return;
    footIO = new IntersectionObserver(function (en) {
      var b = $('[data-wc-sticky]', drawer); if (!b) return;
      var past = en[0].isIntersecting || en[0].boundingClientRect.top < 0;
      b.classList.toggle('is-on', !past);
    }, { rootMargin: '0px 0px -40px 0px' });
    footIO.observe(foot);
  }
  document.addEventListener('wn:cart:updated', watchFoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchFoot); else setTimeout(watchFoot, 0);
  document.addEventListener('scroll', function (e) { var r = e.target; if (r && r.matches && r.matches('[data-wc-rail]')) railSync(r); }, true);
  document.addEventListener('toggle', function (e) { if (e.target.matches && e.target.matches('[data-wc-b2x]')) requestAnimationFrame(railsAll); }, true);
  document.addEventListener('wn:cart:updated', function () { requestAnimationFrame(railsAll); });
  window.addEventListener('resize', railsAll);
  if (drawer) drawer.addEventListener('transitionend', railsAll);

  window.WNCart = {
    __wc: true,
    open: open,
    close: close,
    refresh: refresh,
    add: add,
    toast: toast,
    state: state,
    idle: function () { var c = chain; return c.then(function () { return c === chain ? null : window.WNCart.idle(); }); }
  };

  tick();
  /* first paint: bring managed lines in line with the server-rendered cart */
  var boot = function () { if (state()) enqueue(reconcile); };
  if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 1500 }); else setTimeout(boot, 300);
})();
